import React, { useState, useEffect } from 'react';
import { Paper, Tabs, Tab } from '@material-ui/core';
import { browserHistory } from 'react-router';

const QuickBook = ({ location }) => {
  const tabItems = [{ label: 'Chart Of Account', path: '/chart-of-account' }, { label: 'Product & Services', path: '/qb_product_service' }];

  const getTabIndexFromPath = (pathname) => {
    if (pathname?.startsWith('/chart-of-account')) return 0;
    if (pathname?.startsWith('/qb_product_service')) return 1;
    return 0;
  };

  const [tabIndex, setTabIndex] = useState(getTabIndexFromPath(window.location.pathname));

  useEffect(() => {
    const index = getTabIndexFromPath(window.location.pathname);
    setTabIndex(index);
  }, [window.location.pathname]);

  const handleChange = (event, newIndex) => {
    setTabIndex(newIndex); 
    browserHistory.push(tabItems[newIndex].path);
  };

  return (
    <Paper style={{ marginBottom: '3px' }}>
      <Tabs value={tabIndex} onChange={handleChange} indicatorColor="primary" textColor="primary" centered variant="fullWidth" >
        {tabItems.map((item, index) => (
          <Tab key={index} label={item.label} />
        ))}
      </Tabs>
    </Paper>
  );
};

export default QuickBook;
